/**
 * Load an organization logo URL as a data URL for pdfmake embedding.
 * Returns null when no URL, fetch fails, or image cannot be read — never throws.
 *
 * @param {string|null|undefined} logoUrl
 * @returns {Promise<string|null>}
 */
export async function loadOrgLogoAsDataUrl(logoUrl) {
  if (!logoUrl || typeof logoUrl !== "string") {
    return null;
  }

  const trimmed = logoUrl.trim();
  if (!trimmed) {
    return null;
  }

  try {
    const response = await fetch(trimmed);
    if (!response.ok) {
      console.warn("[loadOrgLogoAsDataUrl] fetch failed", response.status, trimmed);
      return null;
    }

    const blob = await response.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result || null);
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.warn("[loadOrgLogoAsDataUrl] unable to load logo", err);
    return null;
  }
}
